
import { useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Areas from './components/Areas';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    const handleScroll = () => {
      const nav = document.querySelector('nav');
      if (!nav) return;
      if (window.scrollY > 100) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', handleScroll);

    // Homepage Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'home-schema';
    script.text = JSON.stringify([
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "@id": `${import.meta.env.VITE_SITE_URL || 'https://beyondelectrical.co.uk'}/#business`,
        "name": "Beyond Electrical Services",
        "description": "NICEIC approved electricians in Watford providing installations, repairs, safety testing and compliance services for domestic and commercial properties.",
        "url": import.meta.env.VITE_SITE_URL || 'https://beyondelectrical.co.uk',
        "logo": `${import.meta.env.VITE_SITE_URL || 'https://beyondelectrical.co.uk'}/logo.png`,
        "image": `${import.meta.env.VITE_SITE_URL || 'https://beyondelectrical.co.uk'}/og-image.jpg`,
        "telephone": "+447989675952",
        "email": "admin@beyondelectrical.co.uk",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Watford",
          "addressRegion": "Hertfordshire",
          "addressCountry": "GB"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 51.6565,
          "longitude": -0.3957
        },
        "areaServed": [
          { "@type": "City", "name": "Watford" },
          { "@type": "City", "name": "Rickmansworth" },
          { "@type": "City", "name": "Bushey" },
          { "@type": "City", "name": "Croxley Green" },
          { "@type": "City", "name": "Abbots Langley" },
          { "@type": "City", "name": "Chorleywood" },
          { "@type": "City", "name": "Northwood" },
          { "@type": "City", "name": "Pinner" },
          { "@type": "City", "name": "Borehamwood" },
          { "@type": "City", "name": "Radlett" }
        ],
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "Electrical Services",
          "itemListElement": [
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Electrical Installations" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "House Rewiring" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Consumer Unit Upgrades" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "EV Charger Installation" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "EICR Testing" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Emergency Electrician" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Landlord Safety Certificates" } },
            { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Smart Home Installation" } }
          ]
        },
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
            "opens": "08:00",
            "closes": "18:00"
          },
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Saturday","Sunday"],
            "opens": "00:00",
            "closes": "23:59",
            "description": "24/7 Emergency Call-Outs"
          }
        ],
        "priceRange": "££",
        "currenciesAccepted": "GBP",
        "paymentAccepted": "Cash, Credit Card, Bank Transfer",
        "sameAs": [
          "https://www.facebook.com/Beyondelectricalservices/",
          "https://www.instagram.com/beyond_electrical/"
        ]
      },
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "url": import.meta.env.VITE_SITE_URL || 'https://beyondelectrical.co.uk',
        "name": "Beyond Electrical Services",
        "description": "NICEIC approved electricians in Watford",
        "potentialAction": {
          "@type": "SearchAction",
          "target": `${import.meta.env.VITE_SITE_URL || 'https://beyondelectrical.co.uk'}/?s={search_term_string}`,
          "query-input": "required name=search_term_string"
        }
      }
    ]);
    document.head.appendChild(script);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      const s = document.getElementById('home-schema');
      if (s) document.head.removeChild(s);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0A1628]">
      <Hero />
      <About />
      <Services />
      <Gallery />
      <Areas />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}
